import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Beliefs from './pages/Beliefs';
import Practice from './pages/Practice';
import Prayer from './pages/Prayer';
import Codex from './pages/Codex';
import About from './pages/About';
import Support from './pages/Support';
import Contact from './pages/Contact';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/beliefs" element={<Beliefs />} />
              <Route path="/practice" element={<Practice />} />
              <Route path="/prayer" element={<Prayer />} />
              <Route path="/codex" element={<Codex />} />
              <Route path="/about" element={<About />} />
              <Route path="/support" element={<Support />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;